export default {"src":"/_next/static/media/0x352Cb5E19b12FC216548a2677bD0fce83BaE434B.007af426.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};